import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { blockTestRender } from '../../../util/process';
import PageTitle from '../../common/PageTitle';

const LISTING_COUNT = 6;
const LISTING_HEIGHT = 90;
const LISTING_WIDTH = '100%';

const ManufacturerListPageSkeleton = () => {
  return (
    <div className="ManufacturerListPageSkeleton">
      <div className="Skeleton__spacer" />
      {blockTestRender() && <Skeleton height={20} width={320} />}
      <div className="Skeleton__spacer" />
      <PageTitle>
        {blockTestRender() && <Skeleton height={40} width={260} />}
      </PageTitle>
      <div className="Skeleton__spacer" />
      {blockTestRender() &&
        Array.from({ length: LISTING_COUNT }).map((_, index) => (
          <div
            key={`manufacturer-listing-${index}`}
            className="ManufacturerListPageSkeleton__listing"
          >
            <Skeleton height={LISTING_HEIGHT} width={LISTING_WIDTH} />
            {index < LISTING_COUNT - 1 && <div className="Skeleton__spacer" />}
          </div>
        ))}
    </div>
  );
};

export default ManufacturerListPageSkeleton;
